import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/followup/`;

export const followUp = {
  get: () => generateApiPath(pathBase),
};
